import { ConfigProvider, Spin } from 'antd';

import { TableWrapper } from '../../../../../components/index';
import { DockingWasteCollectionItemType } from '../../../../../services/wasteCollectionApi';
import { TablePageProps } from '../../Reports';
import { ReportsTable } from '../../styles';
import { columns, isWasteCollectionSent } from './columns';

type EnvironmentTableProps = {
  onOpenDrawer: (docking: DockingWasteCollectionItemType) => void;
  selectedDockingIds: number[];
  onChangeSelection: (dockingIds: number[]) => void;
};

export function EnvironmentTable(
  props: TablePageProps & EnvironmentTableProps
) {
  const {
    dataSource,
    scrollOptions,
    total,
    itemsPerPage,
    onChangePagination,
    isLoading,
    showSizeChanger,
    queryPage,
    onOpenDrawer,
    selectedDockingIds,
    onChangeSelection,
  } = props;

  function customizeRenderEmpty() {
    return <>Não há dados cadastrados.</>;
  }

  return (
    <Spin spinning={isLoading} tip="Carregando...">
      <TableWrapper>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <ReportsTable
            rowKey="docking_id"
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: itemsPerPage || 60,
              pageSize: 60,
              total,
              onChange: onChangePagination,
              showSizeChanger,
              current: queryPage,
            }}
            columns={columns(onOpenDrawer)}
            dataSource={dataSource}
            rowSelection={{
              selectedRowKeys: selectedDockingIds,
              preserveSelectedRowKeys: true,
              onChange: (keys) => onChangeSelection(keys as number[]),
              getCheckboxProps: (record) => {
                const docking = record as DockingWasteCollectionItemType;
                return {
                  disabled:
                    isWasteCollectionSent(docking) &&
                    !selectedDockingIds.includes(docking.docking_id),
                };
              },
            }}
            scroll={
              scrollOptions || { y: '60vh', scrollToFirstRowOnChange: false }
            }
          />
        </ConfigProvider>
      </TableWrapper>
    </Spin>
  );
}
